import { useContext } from "react";

import type { Session } from "../model/session";
import { SessionContext } from "./session-context";

/** The signed-in caller's session; throws outside SessionProvider so a missing mount fails loudly. */
export function useSession(): Session {
  const session = useContext(SessionContext);
  if (!session) throw new Error("useSession must be used within SessionProvider");
  return session;
}
